import { createSlice } from '@reduxjs/toolkit'

const initialState = { unit:[]}

const userSlice = createSlice({
  name: 'unit',
  initialState,
  reducers: {
    addUnit(state, action) {
       return action.payload
    }
  },
})

export const { addUnit } = userSlice.actions
export default userSlice.reducer